export default __webpack_public_path__ + "static/media/queretaro.f37b7d73.jpg";